/* Send Danish visitors to the English storefront on their first visit. A manual language choice is remembered. */
(function () {
  try {
    var p = location.pathname;
    if (p === '/en' || p.indexOf('/en/') === 0) { localStorage.setItem('bb_lang_set', '1'); return; }
    if (/^\/(cart|checkouts?|account|customer_authentication|services|apps|admin)(\/|$)/.test(p)) return;
    if (localStorage.getItem('bb_lang_set')) return;
    var langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || '']);
    var first = String(langs[0] || '').toLowerCase();
    var tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    var danish = first.indexOf('da') === 0 || tz === 'Europe/Copenhagen';
    if (!danish) return;
    if (first.indexOf('sv') === 0) return;
    localStorage.setItem('bb_lang_set', '1');
    location.replace('/en' + (p === '/' ? '' : p) + location.search + location.hash);
  } catch (e) {}
})();
